(function () {
  var KEY = 'wc_np';
  var bar = document.getElementById('wcnp');
  if (!bar) return;
  var btn = document.getElementById('np-toggle');
  var titleEl = document.getElementById('np-title');
  var fill = document.getElementById('np-fill');
  var track = document.getElementById('np-bar');
  var timeEl = document.getElementById('np-time');

  /* Reuse the page's own <audio> when there is one (Root Access has #sp-audio) so the two
     never fight over playback; otherwise create ours. */
  var audio = document.getElementById('sp-audio');
  if (!audio) {
    audio = document.createElement('audio');
    audio.id = 'wc-np-audio';
    audio.preload = 'none';
    document.body.appendChild(audio);
  }

  /* DOES THIS PAGE OWN PLAYBACK? Root Access (wc-stream) has a full player — big play button,
     seek, synced lyrics keyed to measured cue times. Rendering a second bar on top of it would
     be the duplicate-chrome mistake again, and both would fight over #sp-audio. On that page we
     show nothing and only RECORD state, which is exactly what lets the bar pick the track up
     the moment you navigate away. Everywhere else, this bar IS the player.
     This check has to run BEFORE any listener is bound, or the page double-saves. */
  if (document.querySelector('.sp-row[data-src]')) {
    var mark = function () {
      var n = Date.now();
      if (!audio._wcSaved || n - audio._wcSaved > 1000) { audio._wcSaved = n; save(); }
    };
    audio.addEventListener('timeupdate', mark);
    ['play', 'pause'].forEach(function (ev) { audio.addEventListener(ev, save); });
    audio.addEventListener('ended', clear);
    window.addEventListener('pagehide', save);
    return;
  }

  var PLAY = '<svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor"><path d="m7.05 3.606 13.49 7.788a.7.7 0 0 1 0 1.212L7.05 20.394A.7.7 0 0 1 6 19.788V4.212a.7.7 0 0 1 1.05-.606"/></svg>';
  var PAUSE = '<svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor"><path d="M5.7 3h3.2v18H5.7zm9.4 0h3.2v18h-3.2z"/></svg>';

  function fmt(s) {
    if (!isFinite(s) || s < 0) s = 0;
    var m = Math.floor(s / 60), r = Math.floor(s % 60);
    return m + ':' + (r < 10 ? '0' : '') + r;
  }
  function read() {
    try { return JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (e) { return null; }
  }
  function save() {
    if (!audio.src) return;
    /* On Root Access the page owns the UI, so our own titleEl is still the placeholder —
       take the track name from that page's now-playing label instead, or the highlighted
       row, so the bar carries the right title after you navigate away. */
    var np = document.getElementById('sp-npt');
    var row = document.querySelector('.sp-row.playing .sp-name, .sp-row[aria-current] .sp-name');
    var name = (np && np.textContent.trim()) || (row && row.textContent.trim()) ||
               titleEl.textContent;
    try {
      sessionStorage.setItem(KEY, JSON.stringify({
        src: audio.src,
        title: name,
        pos: audio.currentTime || 0,
        playing: !audio.paused
      }));
    } catch (e) {}
  }
  function clear() { try { sessionStorage.removeItem(KEY); } catch (e) {} }

  /* THE STACKING RULE. Checkout stays at the very bottom; this sits directly on top of it.
     Measured at runtime because the cart bar only renders when the cart has items, and its
     height changes with viewport. */
  function stack() {
    var cb = document.querySelector('.wcb');
    var h = 0;
    if (cb && getComputedStyle(cb).display !== 'none') {
      var r = cb.getBoundingClientRect();
      /* only offset when it is genuinely pinned to the bottom */
      if (r.height && Math.abs(window.innerHeight - r.bottom) < 4) h = Math.round(r.height);
    }
    bar.style.bottom = h + 'px';
  }

  function show(on) {
    bar.classList.toggle('on', !!on);
    if (on) stack();
  }

  function paint() {
    var d = audio.duration, c = audio.currentTime || 0;
    fill.style.width = (d && isFinite(d) ? (c / d * 100) : 0) + '%';
    timeEl.textContent = fmt(c);
    btn.innerHTML = audio.paused ? PLAY : PAUSE;
    btn.setAttribute('aria-label', audio.paused ? 'Play' : 'Pause');
  }

  /* Public handoff — any page player calls this instead of managing its own bar. */
  window.WCPlayer = {
    play: function (src, title) {
      if (!src) return;
      if (audio.src !== src) { audio.src = src; audio.currentTime = 0; }
      titleEl.textContent = title || 'Unknown track';
      show(true);
      var p = audio.play();
      if (p && p.catch) p.catch(function () { paint(); });
      save();
    },
    stop: function () { try { audio.pause(); } catch (e) {} show(false); clear(); },
    restack: stack
  };

  btn.addEventListener('click', function () {
    if (audio.paused) { var p = audio.play(); if (p && p.catch) p.catch(function () {}); }
    else audio.pause();
    save();
  });
  document.getElementById('np-close').addEventListener('click', function () { window.WCPlayer.stop(); });

  track.addEventListener('click', function (e) {
    var d = audio.duration;
    if (!d || !isFinite(d)) return;
    var r = track.getBoundingClientRect();
    audio.currentTime = Math.max(0, Math.min(1, (e.clientX - r.left) / r.width)) * d;
    save();
  });

  audio.addEventListener('timeupdate', function () {
    paint();
    /* throttle writes to ~1/sec rather than every frame */
    var n = Date.now();
    if (!audio._wcSaved || n - audio._wcSaved > 1000) { audio._wcSaved = n; save(); }
  });
  ['play', 'pause'].forEach(function (ev) { audio.addEventListener(ev, function () { paint(); save(); }); });
  audio.addEventListener('ended', function () { clear(); show(false); });
  window.addEventListener('pagehide', save);
  window.addEventListener('resize', stack);

  /* RESTORE. Browsers block autoplay without a gesture, so if resume is refused the bar still
     appears with the track cued and paused — the user taps once and continues where they were.
     That is the honest behaviour; pretending it auto-resumed would be worse. */
  /* ONLY FOLLOW MUSIC THAT IS ACTUALLY PLAYING (Josh: "It should only be there if the user has
     initiated playing it"). This used to restore the bar whenever ANY track was remembered,
     playing or not — so once you pressed play anywhere, the bar reappeared on every page for
     the rest of the tab's life, cued and paused, including on the cart. That reads as the site
     following you around rather than a player continuing your music.

     Note on what was NOT the cause, since both were plausible and both are ruled out: a
     genuinely fresh session hides the bar (sessionStorage cleared → display:none), and merely
     VISITING Root Access without pressing play writes nothing. The over-persistence is the
     whole mechanism, and it only ends when the tab closes.

     The bar's job is to keep playing audio alive across navigation. Paused audio has no such
     job, so a paused track is forgotten on the next page rather than trailing after you. */
  var st = read();
  if (st && st.src && !st.playing) { clear(); st = null; }
  if (st && st.src) {
    audio.src = st.src;
    titleEl.textContent = st.title || '—';
    var seek = function () {
      try { if (st.pos) audio.currentTime = st.pos; } catch (e) {}
      audio.removeEventListener('loadedmetadata', seek);
      paint();
    };
    audio.addEventListener('loadedmetadata', seek);
    show(true);
    if (st.playing) {
      var pr = audio.play();
      if (pr && pr.catch) pr.catch(function () { paint(); });
    }
    paint();
  }

  /* The cart bar can appear after us (added to cart, or injected late) — keep the offset true. */
  if (window.MutationObserver) {
    new MutationObserver(stack).observe(document.body, { childList: true, subtree: false });
  }
})();
